import { useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const PhoneReminder = () => {
  const [busy, setBusy] = useState(false);
  const test = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/phone-reminder/test");
      toast.success(`Email di prova inviata a ${data.recipients.join(", ")}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="phone-reminder-box" className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-md border border-slate-200 bg-slate-50 px-3 py-2.5">
      <BellRing size={16} className="text-[#15803D] shrink-0" />
      <p className="text-xs text-slate-600 flex-1">Promemoria telefono: se l'app WhatsApp Business non viene aperta da 10 giorni, ogni giorno alle 9:00 gli amministratori e l'email aziendale ricevono un'email e una notifica push, finché il telefono non viene riaperto.</p>
      <Button data-testid="phone-reminder-test-button" variant="outline" size="sm" onClick={test} disabled={busy}>
        {busy ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <BellRing size={14} className="mr-1.5" />}Invia email di prova
      </Button>
    </div>
  );
};
